import Vue from 'vue'
import VueRouter from 'vue-router'
import { Route } from 'vue-router';
import Home from '@/views/locker/Home.vue'
import InstallList from "@/views/locker/InstallList.vue";
import InstallLocker from "@/views/locker/InstallLocker.vue";
import LockerList from "@/views/locker/LockerList.vue";
import LockersContracts from "@/views/locker/LockersContracts.vue";
import LockersScreensavers from "@/views/screensaver/LockersScreensavers.vue";
import ScreensaversLockers from "@/views/screensaver/ScreensaversLockers.vue";
import UserPermissions from "@/views/user/UserPermissions.vue";
import SwaggerModulo from "@/views/swagger/SwaggerModulo.vue";
import UserPackageDelivery from "@/views/order/UserPackageDelivery.vue";
import Order from "@/views/order/Order.vue";
import PermissionMapEditor from "@/views/permissions/PermissionMapEditor.vue";
import UserList from "@/views/user/UserList.vue";
import User from "@/views/user/User.vue";
import UserPromotions from "@/views/user/UserPromotions.vue";
import WhoHas from "@/views/permissions/WhoHas.vue";
import UserImport from "@/views/user/UserImport.vue";
import UserCommunications from "@/views/user/UserCommunications.vue";
import Holidays from "@/views/settings/Holidays.vue";
import Zones from "@/views/settings/Zones.vue";
import Couriers from "@/views/settings/Couriers.vue";
import ServiceProviderList from "@/views/serviceProvider/ServiceProviderList.vue";
import Zone from "@/views/settings/Zone.vue";
import LockersServiceProviders from "@/views/serviceProvider/LockersServiceProviders.vue";
import ServiceProvidersCommunities from "@/views/serviceProvider/ServiceProvidersCommunities.vue";
import ServiceProvider from "@/views/serviceProvider/ServiceProvider.vue";
import ServiceProviderCreate from "@/views/serviceProvider/ServiceProviderCreate.vue";
import ServiceProviderCategories from "@/views/serviceProvider/ServiceProviderCategories.vue";
import ServiceProviderTimeLine from "@/views/serviceProvider/ServiceProviderTimeLine.vue";
import ServiceProvidersServices from "@/views/serviceProvider/ServiceProvidersServices.vue";
import ServiceProvidersPromotions from "@/views/serviceProvider/ServiceProvidersPromotions.vue";
import ServiceProviderProducts from "@/views/serviceProvider/ServiceProviderProducts.vue";
import ServiceEdit from "@/views/serviceProvider/ServiceEdit.vue";
import OrderList from "@/views/order/OrderList.vue";
import WebhoookList from "@/views/webhook/WebhookList.vue";
import UserOrderList from "@/views/user/UserOrderList.vue";
import ScreensaversList from "@/views/screensaver/ScreensaversList.vue";
import Locker from "@/views/locker/Locker.vue";
import LockerEdit from "@/views/locker/LockerEdit.vue";
import LockerCreate from "@/views/locker/LockerCreate.vue";
import LandingPages from "@/views/settings/LandingPages.vue";
import ScreensaverInfo from "@/views/screensaver/ScreensaverInfo.vue";
import PackagesToTransfer from "@/views/locker/PackagesToTransfer.vue";
import {i18n} from '@/helpers/translations';
import store from '@/store';
import {PermissionHelper} from '@/helpers/PermissionHelper';
import {EUserPermissions} from '@/model/EUserPermissions';
import {EPermissionActions} from '@/model/EPermissionActions';
import LockersOrders from "@/views/locker/LockersOrders.vue";
import ContractForm from "@/views/locker/ContractForm.vue";
import LockerFeatures from "@/views/locker/LockerFeatures.vue";
import DiffusionExpress from "@/views/user/DiffusionExpress.vue";
import UserEdit from "@/views/user/UserEdit.vue";
import UserAddresses from "@/views/user/UserAddresses.vue";
import UserMgm from "@/views/user/UserMgm.vue";
import UserAuditLogs from "@/views/user/UserAuditLogs.vue";
import LockerCompaniesList from "@/views/lockerCompanies/LockerCompaniesList.vue";
import Reports from "@/views/reports/Reports.vue";
import ReportsGeneral from "@/views/reports/ReportsGeneral.vue";
import ReportsRegistrations from "@/views/reports/ReportsRegistrations.vue";
import ApiKeys from "@/views/settings/ApiKeys.vue";
import AuditLogs from "@/views/settings/AuditLogs.vue";
import IdentityIntegrations from "@/views/settings/IdentityIntegrations.vue";
import IdentityIntegration from "@/views/settings/IdentityIntegration.vue";
import Channels from "@/views/settings/Channels.vue";
import Messages from "@/views/settings/Messages.vue";
import Modules from "@/views/settings/Modules.vue";
import Translations from "@/views/settings/Translations.vue";
import Realtime from "@/views/realtime/Realtime.vue";
import StandalonesList from '@/views/standalone/StandalonesList.vue';
import StandalonesGlobalList from '@/views/standalone/StandalonesGlobalList.vue';
import StandalonePreview from '@/views/standalone/StandalonePreview.vue';
import SshConnectionsList from "@/views/sshConnections/SshConnectionsList.vue";
import ServiceProviderMetrics from "@/views/serviceProvider/ServiceProviderMetrics.vue";
import CommunityList from "@/views/community/CommunityList.vue";
import Community from "@/views/community/Community.vue";
import CommunityEdit from "@/views/community/CommunityEdit.vue";
import CommunityModule from "@/views/community/CommunityModule.vue";
import CommunityCreate from "@/views/community/CommunityCreate.vue";
import CommunityLockers from "@/views/community/CommunityLockers.vue";
import SecurityCodeList from "@/views/community/SecurityCodeList.vue";
import CommunityB2bInvites from "@/views/community/CommunityB2bInvites.vue";
import BusinessClientList from "@/views/businessClient/BusinessClientList.vue";
import BusinessClient from "@/views/businessClient/BusinessClient.vue";
import BusinessClientEdit from "@/views/businessClient/BusinessClientEdit.vue";
import BusinessClientCreate from "@/views/businessClient/BusinessClientCreate.vue";
import BusinessClientCommunities from "@/views/businessClient/BusinessClientCommunities.vue";
import CommunityContacts from "@/views/community/CommunityContacts.vue";
import CommunityOrders from "@/views/community/CommunityOrders.vue";
import CommunityServiceProviders from "@/views/community/CommunityServiceProviders.vue";
import CommunityUsers from "@/views/community/CommunityUsers.vue";
import RouteList from "@/views/route/RouteList.vue";
import RouteDetail from "@/views/route/Route.vue";
import RouteCreate from "@/views/route/RouteCreate.vue";
import RouteEdit from "@/views/route/RouteEdit.vue";
import SubscriptionList from "@/views/subscription/SubscriptionList.vue";
import OrderEdit from "@/views/order/OrderEdit.vue";
import OrderCreate from "@/views/order/OrderCreate.vue";
import OrderPrint from "@/views/order/OrderPrint.vue";
import InvoiceList from "@/views/invoice/InvoiceList.vue";
import Invoice from "@/views/invoice/Invoice.vue";
import InvoiceCreate from "@/views/invoice/InvoiceCreate.vue";
import RentbackSettings from "@/views/rentback/RentbackSettings.vue";
import RentbackSettingsEdit from "@/views/rentback/RentbackSettingsEdit.vue";
import RentbackList from "@/views/rentback/RentbackList.vue";
import HelpdeskLayout from "@/views/helpdesk/HelpdeskLayout.vue";
import HelpdeskDashboard from "@/views/helpdesk/Dashboard.vue";
import HelpdeskInbox from "@/views/helpdesk/Inbox.vue";
import HelpdeskAccounts from "@/views/helpdesk/Accounts.vue";
import HelpdeskTickets from "@/views/helpdesk/Tickets.vue";
import HelpdeskSpamSenders from "@/views/helpdesk/SpamSenders.vue";
import HelpdeskTicketTypes from "@/views/helpdesk/TicketTypes.vue";
import HelpdeskSentEmails from "@/views/helpdesk/SentEmails.vue";
import HelpdeskEmailTemplates from "@/views/helpdesk/EmailTemplates.vue";
import HelpdeskEmailSignatures from "@/views/helpdesk/EmailSignatures.vue";
import HelpdeskWhatsapp from "@/views/helpdesk/Whatsapp.vue";

Vue.use(VueRouter);

// fetchActionAccessLevels is debounced: while the startup request (main.ts) is in flight it returns
// at once without data. Wait for the levels themselves (login already brings them).
const actionAccessLevelsLoaded = (): Promise<void> => new Promise((resolve) => {
  if (store.getters['authModule/actionAccessLevels'].length) return resolve();
  let unwatch = () => {};
  const timer = setTimeout(() => { unwatch(); resolve(); }, 5000);
  unwatch = store.watch(
    (_state: any, getters: any) => getters['authModule/actionAccessLevels'].length,
    (count: number) => { if (count) { clearTimeout(timer); unwatch(); resolve(); } },
  );
  store.dispatch('authModule/fetchActionAccessLevels');
});

// Helpdesk access comes from mayordomo's permission_maps (helpdesk/access, helpdesk/admin).
const helpdeskGuardFor = (actions: EPermissionActions[]) => async (_to: Route, _from: Route, next: any) => {
  await actionAccessLevelsLoaded();
  const canAction = store.getters['authModule/canAction'];
  actions.some((action) => canAction(action)) ? next() : next('/');
};
const helpdeskGuard = helpdeskGuardFor([EPermissionActions.ACTION_HELPDESK_ACCESS, EPermissionActions.ACTION_HELPDESK_ADMIN]);
const helpdeskAdminGuard = helpdeskGuardFor([EPermissionActions.ACTION_HELPDESK_ADMIN]);
// WhatsApp: admin, or helpdesk access plus helpdesk/whatsapp (the helpdesk API asks for both).
const helpdeskWhatsappGuard = async (_to: Route, _from: Route, next: any) => {
  await actionAccessLevelsLoaded();
  const canAction = store.getters['authModule/canAction'];
  canAction(EPermissionActions.ACTION_HELPDESK_ADMIN)
    || (canAction(EPermissionActions.ACTION_HELPDESK_ACCESS) && canAction(EPermissionActions.ACTION_HELPDESK_WHATSAPP))
    ? next() : next('/');
};

const communitiesAdminGuard = async (_to: Route, _from: Route, next: any) => {
  await actionAccessLevelsLoaded();
  store.getters['authModule/canAction'](EPermissionActions.ACTION_COMMUNITIES_ADMIN) ? next() : next('/');
};

const parseIntProps = (propName: string) => (route: any) => {
  const props = { ...route.params }
  let lockerId = parseInt(props[propName])
  props[propName] = isNaN(lockerId) ? 0 : lockerId;
  return props
}

const routes = [
  {
    // hack to catch full path urls (for old backoffice links), matches http and https
    path : '/*http*',
    beforeEnter: (to: any, from: any, next: any) => {
      window.location.href = to.fullPath.substring(to.fullPath.lastIndexOf('http'));
    },
  },
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    // Helpdesk pages share HelpdeskLayout (top nav). Paths, names and guards are the same as when
    // they were top-level routes; each child keeps its own guard.
    path: '/helpdesk',
    component: HelpdeskLayout,
    children: [
      {path: '', name: 'helpdeskDashboard', component: HelpdeskDashboard, beforeEnter: helpdeskGuard},
      {path: 'inbox', name: 'helpdeskInbox', component: HelpdeskInbox, beforeEnter: helpdeskGuard},
      {path: 'accounts', name: 'helpdeskAccounts', component: HelpdeskAccounts, beforeEnter: helpdeskAdminGuard},
      {path: 'tickets', name: 'helpdeskTickets', component: HelpdeskTickets, beforeEnter: helpdeskGuard},
      {path: 'spam', name: 'helpdeskSpam', component: HelpdeskSpamSenders, beforeEnter: helpdeskGuard},
      {path: 'ticket-types', name: 'helpdeskTicketTypes', component: HelpdeskTicketTypes, beforeEnter: helpdeskGuard},
      {path: 'sent', name: 'helpdeskSent', component: HelpdeskSentEmails, beforeEnter: helpdeskGuard},
      {path: 'templates', name: 'helpdeskTemplates', component: HelpdeskEmailTemplates, beforeEnter: helpdeskGuard},
      {path: 'signatures', name: 'helpdeskSignatures', component: HelpdeskEmailSignatures, beforeEnter: helpdeskGuard},
      {path: 'whatsapp', name: 'helpdeskWhatsapp', component: HelpdeskWhatsapp, beforeEnter: helpdeskWhatsappGuard},
    ],
  },
  {
    path: '/lockers/:lockerId/serviceProviders',
    name: 'lockersServiceProviders',
    // props: parseIntProps("lockerId"),
    component: LockersServiceProviders
  },
  {
    path: '/lockers/:lockerId/screensavers',
    name: 'lockersScreensavers',
    component: LockersScreensavers,
    props: parseIntProps("lockerId"),
  },
  {
    path: '/install/list',
    name: 'installList',
    component: InstallList
  },
  {
    path: '/install/:lockerId',
    name: 'installLocker',
    component: InstallLocker,
  },
  {
    path: '/lockers/list',
    name: 'lockerList',
    component: LockerList,
  },
  {
    path: '/lockers/features',
    name: 'lockerFeatures',
    component: LockerFeatures,
  },
  {
    path: '/lockers/create',
    name: 'lockerCreate',
    component: LockerCreate,
    beforeEnter: (_to: any, _from: any, next: any) => {
      const canAction = store.getters['authModule/canAction'];
      canAction(EPermissionActions.ACTION_LOCKERS_CREATE) ? next() : next('/');
    },
  },
  {
    path: '/lockers/:lockerId/contracts/',
    name: 'lockersContracts',
    component: LockersContracts,
    props: parseIntProps('lockerId'),
  },
  {
    path: '/lockers/:lockerId/contracts/create',
    name: 'lockersContractsCreate',
    component: ContractForm,
    props: parseIntProps('lockerId'),
  },
  {
    path: '/lockers/:lockerId/contracts/:entityId',
    name: 'lockersContract',
    component: ContractForm,
    props: parseIntProps("lockerId"),
  },
  {
    path: '/lockers/:lockerId',
    name: 'locker',
    component: Locker,
    props: parseIntProps('lockerId'),
  },
  {
    path: '/lockers/:lockerId/edit',
    name: 'lockerEdit',
    component: LockerEdit,
    props: parseIntProps('lockerId'),
  },
  {
    path: '/lockers/:lockerId/landingpages',
    name: 'lockersLandingpages',
    component: LandingPages,
    props: parseIntProps('lockerId'),
  },
  {
    path: '/lockers/:lockerId/standalones',
    name: 'standalonesList',
    component: StandalonesList,
    props: parseIntProps('lockerId'),
  },
  {
    path: '/lockers/:lockerId/standalone/:deviceId/preview',
    name: 'standalonePreview',
    component: StandalonePreview,
    meta: { simpleLayout: true },
    props: (route: { params: { lockerId: number; deviceId: string; }; }) => ({
      lockerId: Number(route.params.lockerId) || 0,
      deviceId: route.params.deviceId || '0',
    }),
  },
  {
    path: '/lockers/:lockerId/packagesToTransfer',
    name: 'packagesToTransfer',
    component: PackagesToTransfer,
    props: parseIntProps('lockerId'),
  },
  {
    path: '/lockers/:lockerId/orders',
    name: 'lockersOrders',
    component: LockersOrders,
    props: parseIntProps('lockerId'),
  },
  {
    path: '/routes/list',
    name: 'routeList',
    component: RouteList,
  },
  {
    path: '/routes/create',
    name: 'routeCreate',
    component: RouteCreate,
  },
  {
    path: '/routes/:routeId',
    name: 'route',
    component: RouteDetail,
    props: parseIntProps('routeId'),
  },
  {
    path: '/routes/:routeId/edit',
    name: 'routeEdit',
    component: RouteEdit,
    props: parseIntProps('routeId'),
  },

  {
    path: '/orders/list',
    name: 'orderList',
    component: OrderList,
  },
  {
    path: '/subscriptions/list',
    name: 'subscriptionList',
    component: SubscriptionList,
    beforeEnter: (_to: any, _from: any, next: any) => {
      PermissionHelper.canViewSubscriptions(store.getters['authModule/userData']) ? next() : next('/');
    },
  },
  {
    path: '/orders/create',
    name: 'orderCreate',
    component: OrderCreate,
    beforeEnter: (_to: any, _from: any, next: any) => {
      const canAction = store.getters['authModule/canAction'];
      canAction(EPermissionActions.ACTION_ORDERS_CREATE) ? next() : next('/');
    },
  },
  {
    path: '/orders/:orderId/edit',
    name: 'orderEdit',
    component: OrderEdit,
    beforeEnter: (_to: any, _from: any, next: any) => {
      const canAction = store.getters['authModule/canAction'];
      canAction(EPermissionActions.ACTION_ORDERS_UPDATE) ? next() : next('/');
    },
  },
  {
    path: '/orders/:orderId/print',
    name: 'orderPrint',
    component: OrderPrint,
    props: parseIntProps('orderId'),
  },
  {
    path: '/orders/:orderId',
    name: 'order',
    component: Order,
  },
  {
    path: '/orders/packageDelivery/:userId',
    name: 'userPackageDelivery',
    component: UserPackageDelivery,
    props: parseIntProps('userId'),
  },
  {
    path: '/invoices/list',
    name: 'invoiceList',
    component: InvoiceList,
  },
  {
    path: '/invoices/create',
    name: 'invoiceCreate',
    component: InvoiceCreate,
  },
  {
    path: '/invoices/:invoiceId',
    name: 'invoice',
    component: Invoice,
  },

  {
    path: '/permissions/permissionMap',
    name: 'permissionMap',
    component: PermissionMapEditor,
  },
  {
    path: '/permissions/whoHas/:permissionId?',
    name: 'permissionWhoHas',
    component: WhoHas,
    props: parseIntProps("permissionId"),
  },

  {
    path: '/realtime',
    name: 'realtime',
    component: Realtime,
  },

  {
    path: '/reports/general',
    name: 'reportsGeneral',
    component: ReportsGeneral,
  },
  {
    path: '/reports',
    name: 'reports',
    component: Reports,
  },
  {
    path: '/reports/registrations',
    name: 'reportsRegistrations',
    component: ReportsRegistrations,
    beforeEnter: async (_to: Route, _from: Route, next: any) => {
      await actionAccessLevelsLoaded();
      store.getters['authModule/canAction'](EPermissionActions.ACTION_REPORTS) ? next() : next('/');
    },
  },

  {
    path: '/screensavers/list',
    name: 'screensavers',
    component: ScreensaversList,
  },
  {
    path: '/screensavers/create/:type',
    name: 'screensaverCreate',
    component: ScreensaverInfo,
    props: true,
  },
  {
    path: '/screensavers/:screensaverId',
    name: 'screensaverInfo',
    component: ScreensaverInfo,
    props: parseIntProps("screensaverId"),
  },
  {
    path: '/screensavers/:screensaverId/lockers',
    name: 'screensaversLockers',
    component: ScreensaversLockers
  },

  {
    path: '/serviceProviders/list',
    name: 'serviceProviderList',
    component: ServiceProviderList,
  },
  {
    path: '/serviceProviders/create',
    name: 'serviceProviderCreate',
    component: ServiceProviderCreate,
  },
  {
    path: '/serviceProviders/:spId',
    name: 'serviceProvider',
    props: parseIntProps("spId"),
    component: ServiceProvider,
  },
  {
    path: '/serviceProviders/:spId/services',
    name: 'serviceProvidersServices',
    props: parseIntProps("spId"),
    component: ServiceProvidersServices,
  },
  {
    path: '/serviceProviders/:spId/services/create',
    name: 'serviceCreate',
    props: parseIntProps("spId"),
    component: ServiceEdit,
  },
  {
    path: '/serviceProviders/:spId/services/:serviceId',
    name: 'serviceEdit',
    props: (route: any) => ({
      spId: parseInt(route.params.spId) || 0,
      serviceId: parseInt(route.params.serviceId) || 0,
    }),
    component: ServiceEdit,
  },
  {
    path: '/serviceProviders/:spId/promotions',
    name: 'serviceProvidersPromotions',
    props: parseIntProps("spId"),
    component: ServiceProvidersPromotions,
  },
  {
    path: '/products',
    name: 'products',
    component: ServiceProviderProducts,
  },
  {
    path: '/serviceProviders/:spId/products',
    name: 'serviceProviderProducts',
    props: parseIntProps("spId"),
    component: ServiceProviderProducts,
  },
  {
    path: '/serviceProviders/:spId/communities',
    name: 'serviceProvidersLockers',
    props: parseIntProps("spId"),
    component: ServiceProvidersCommunities,
  },
  {
    path: '/serviceProviders/categories/:categoryId?',
    name: 'serviceProviderCategories',
    props: parseIntProps('categoryId'),
    component: ServiceProviderCategories,
  },
  {
    path: '/serviceProviders/timeline',
    name: 'serviceProviderTimeLine',
    component: ServiceProviderTimeLine,
  },
  {
    path: '/settings/messages',
    name: 'messages',
    component: Messages,
  },
  {
    path: '/settings/translations',
    name: 'translations',
    component: Translations,
  },
  {
    path: '/settings/channels',
    name: 'channels',
    component: Channels,
  },
  {
    path: '/settings/modules',
    name: 'settingsModules',
    component: Modules,
    beforeEnter: communitiesAdminGuard,
  },
  {
    path: '/settings/holidays',
    name: 'holidays',
    component: Holidays,
  },
  {
    path: '/settings/landingpages',
    name: 'landingpages',
    component: LandingPages,
  },
  {
    path: '/settings/zones',
    name: 'zones',
    component: Zones,
  },
  {
    path: '/settings/zones/:zoneId',
    name: 'zone',
    component: Zone,
  },
  {
    path: '/settings/couriers',
    name: 'couriers',
    component: Couriers,
    beforeEnter: async (_to: any, _from: any, next: any) => {
      await store.dispatch('authModule/fetchActionAccessLevels');
      const canAction = store.getters['authModule/canAction'];
      const allowed = canAction(EPermissionActions.ACTION_SETTINGS_COURIERS);
      allowed ? next() : next('/');
    },
  },
  {
    path: '/settings/companies',
    name: 'lockerCompaniesList',
    component: LockerCompaniesList,
  },
  {
    path: '/settings/identity-integrations',
    name: 'identityIntegrations',
    component: IdentityIntegrations,
    beforeEnter: async (_to: any, _from: any, next: any) => {
      await store.dispatch('authModule/fetchActionAccessLevels');
      const canAction = store.getters['authModule/canAction'];
      const allowed = canAction(EPermissionActions.ACTION_IDENTITY_INTEGRATIONS);
      allowed ? next() : next('/');
    },
  },
  {
    path: '/settings/identity-integrations/:integrationId',
    name: 'identityIntegration',
    component: IdentityIntegration,
    props: parseIntProps('integrationId'),
    beforeEnter: async (_to: any, _from: any, next: any) => {
      await store.dispatch('authModule/fetchActionAccessLevels');
      const canAction = store.getters['authModule/canAction'];
      const allowed = canAction(EPermissionActions.ACTION_IDENTITY_INTEGRATIONS);
      allowed ? next() : next('/');
    },
  },
  {
    path: '/settings/apiKeys',
    name: 'apiKeys',
    component: ApiKeys,
    beforeEnter: (_to: any, _from: any, next: any) => {
      const canAction = store.getters['authModule/canAction'];
      const allowed = canAction(EPermissionActions.ACTION_API_KEYS_AUTH_MANAGEMENT);
      allowed ? next() : next('/');
    },
  },
  {
    path: '/settings/audit-logs',
    name: 'auditLogs',
    component: AuditLogs,
    beforeEnter: async (_to: any, _from: any, next: any) => {
      await store.dispatch('authModule/fetchActionAccessLevels');
      const canAction = store.getters['authModule/canAction'];
      const allowed = canAction(EPermissionActions.ACTION_SETTINGS_AUDIT_LOGS);
      allowed ? next() : next('/');
    },
  },
  {
    path: '/swagger/modulo',
    name: 'swaggerUi',
    component: SwaggerModulo,
  },
  {
    path: '/sshconnections/',
    name: 'sshconnections',
    component: SshConnectionsList,
  },
  {
    path: '/clients/list',
    name: 'businessClientList',
    component: BusinessClientList,
  },
  {
    path: '/clients/create',
    name: 'businessClientCreate',
    component: BusinessClientCreate,
  },
  {
    path: '/clients/:clientId',
    name: 'businessClient',
    component: BusinessClient,
    props: parseIntProps('clientId'),
  },
  {
    path: '/clients/:clientId/edit',
    name: 'businessClientEdit',
    component: BusinessClientEdit,
    props: parseIntProps('clientId'),
  },
  {
    path: '/clients/:clientId/communities',
    name: 'businessClientCommunities',
    component: BusinessClientCommunities,
    props: parseIntProps('clientId'),
  },
  {
    path: '/communities/list',
    name: 'communityList',
    component: CommunityList,
  },
  {
    path: '/security-codes/list',
    name: 'securityCodeList',
    component: SecurityCodeList,
  },
  {
    path: '/communities/create',
    name: 'communityCreate',
    component: CommunityCreate,
    beforeEnter: (_to: any, _from: any, next: any) => {
      const canAction = store.getters['authModule/canAction'];
      const allowed = canAction(EPermissionActions.ACTION_COMMUNITIES_CREATE);
      allowed ? next() : next('/');
    },
  },
  {
    path: '/communities/:communityId',
    name: 'community',
    component: Community,
    props: parseIntProps('communityId'),
  },
  {
    path: '/communities/:communityId/edit',
    name: 'communityEdit',
    component: CommunityEdit,
    props: parseIntProps('communityId'),
  },
  {
    path: '/communities/:communityId/modules/:moduleSlug',
    name: 'communityModule',
    component: CommunityModule,
    props: parseIntProps('communityId'),
    beforeEnter: communitiesAdminGuard,
  },
  {
    path: '/communities/:communityId/lockers',
    name: 'communityLockers',
    component: CommunityLockers,
    props: parseIntProps('communityId'),
  },
  {
    path: '/communities/:communityId/b2b-invites',
    name: 'communityB2bInvites',
    component: CommunityB2bInvites,
    props: parseIntProps('communityId'),
    beforeEnter: (_to: any, _from: any, next: any) => {
      const userData = store.getters['authModule/userData'];
      const allowed = PermissionHelper.hasRoleAdministrator(userData)
        && (PermissionHelper.hasPermissionAny(userData, EUserPermissions.PERMISSION_LOCKER_OWNER) || PermissionHelper.hasPermissionAny(userData, EUserPermissions.PERMISSION_LOCKER_OPERATOR));
      allowed ? next() : next('/');
    },
  },
  {
    path: '/communities/:communityId/contacts',
    name: 'communityContacts',
    component: CommunityContacts,
    props: parseIntProps('communityId'),
  },
  {
    path: '/communities/:communityId/orders',
    name: 'communityOrders',
    component: CommunityOrders,
    props: parseIntProps('communityId'),
  },
  {
    path: '/communities/:communityId/service-providers',
    name: 'communityServiceProviders',
    component: CommunityServiceProviders,
    props: parseIntProps('communityId'),
  },
  {
    path: '/communities/:communityId/users',
    name: 'communityUsers',
    component: CommunityUsers,
    props: parseIntProps('communityId'),
  },
  {
    path: '/rentback',
    name: 'rentbackList',
    component: RentbackList,
  },
  {
    path: '/standalones',
    name: 'allStandalonesList',
    component: StandalonesGlobalList,
  },
  {
    path: '/communities/:communityId/standalones',
    name: 'communityStandalonesList',
    component: StandalonesList,
    props: (route: any) => ({
      communityIdProp: parseInt(route.params.communityId) || 0,
    }),
  },
  {
    path: '/users/import',
    name: 'userImport',
    component: UserImport
  },
  {
    path: '/users/diffusionExpress',
    name: 'diffusionExpress',
    component: DiffusionExpress
  },
  {
    path: '/users/list',
    name: 'userList',
    component: UserList
  },
  {
    path: '/users/:userId',
    name: 'user',
    props: parseIntProps('userId'),
    component: User
  },
  {
    path: '/users/:userId/edit',
    name: 'userEdit',
    component: UserEdit,
    props: parseIntProps('userId'),
  },
  {
    path: '/users/:userId/communications',
    name: 'userCommunications',
    component: UserCommunications,
    props: parseIntProps("userId"),
  },
  {
    path: '/users/:userId/permissions',
    name: 'userPermissions',
    component: UserPermissions,
    props: parseIntProps("userId"),
  },
  {
    path: '/users/:userId/promotions',
    name: 'userPromotions',
    component: UserPromotions,
    props: parseIntProps("userId"),
  },
  {
    path: '/users/:userId/orders',
    name: 'userOrderLists',
    component: UserOrderList,
    props: parseIntProps("userId"),
  },
  {
    path: '/users/:userId/addresses',
    name: 'userAddresses',
    component: UserAddresses,
    props: parseIntProps("userId"),
  },
  {
    path: '/users/:userId/mgm',
    name: 'userMgm',
    component: UserMgm,
    props: parseIntProps("userId"),
  },
  {
    path: '/users/:userId/audit-logs',
    name: 'userAuditLogs',
    component: UserAuditLogs,
    props: parseIntProps("userId"),
    beforeEnter: (_to: any, _from: any, next: any) => {
      const userData = store.getters['authModule/userData'];
      const allowed = PermissionHelper.hasPermissionAny(userData, EUserPermissions.PERMISSION_DEVELOPER);
      allowed ? next() : next('/');
    },
  },
  {
    path: '/service-providers/metrics',
    name: 'serviceProviderMetrics',
    component: ServiceProviderMetrics,
    beforeEnter: (_to: any, _from: any, next: any) => {
      const canAction = store.getters['authModule/canAction'];
      const allowed = canAction(EPermissionActions.ACTION_SERVICE_PROVIDERS_METRICS)
        || canAction(EPermissionActions.ACTION_SERVICE_PROVIDERS_METRICS_READ);
      allowed ? next() : next('/');
    },
  },
  {
    path: '/users/:userId?/webhooks',
    name: 'userWebhooks',
    component: WebhoookList,
    props: parseIntProps("userId"),
  },
  {
    path: '*',
    redirect: '/',
  },
];

const router = new VueRouter({
  // mode: 'history',
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to: Route, from: Route, next: any) => {
  const pageTitle = to.name ? to.name : 'Modulo';
  document.title = i18n.t("tabs.titles." + pageTitle).toString();
  next();
});


export default router
